const EnvName = "demo";

let Front_URL,
  Back_URL,
  v1Url,
  decimalvalues = 1000000000000000000,
  toFixed = 6,
  NumOnly = /[^0-9]/g,
  toasterOption,
  Users_URL,
  Common_URL,
  shareTag,
  KEY = "EDAFACENFTMarketPlace#%^09276!!",
  loginurl,
  cookiename = "ssoToken",
  domainname,
  userCookieName = "userkey",
  ssologin;

if (EnvName == "demo") {
  Front_URL = "https://edafacelisting.maticz.in/";
  Back_URL = "https://edafacevav-backend.maticz.in/";
  v1Url = "https://edafacevav-backend.maticz.in/api/v1/";
  Users_URL = "https://edafacevav-backend.maticz.in/api/v1/user";
  Common_URL = "https://edafacevav-backend.maticz.in/api/v1/common";
  ssologin = "https://edaface-sso.maticz.in/"
  domainname = ".maticz.in";
} else if (EnvName == "ip") {
  Front_URL = "http://10.0.1.147:3000/";
  Back_URL = "http://10.0.1.147:3002/";
  v1Url = "http://10.0.1.147:3002/api/v1/";
  Users_URL = "http://10.0.1.147:3002/api/v1/user";
  Common_URL = "http://10.0.1.147:3002/api/v1/common";
  domainname = ".localhost";
} else if (EnvName == "staging") {
} else if (EnvName == "production") {
} else {
  Front_URL = "http://localhost:3000/";
  Back_URL = "http://localhost:3002/";
  v1Url = "http://localhost:3002/api/v1/";
  Users_URL = "http://localhost:3002/api/v1/user";
  Common_URL = "http://localhost:3002/api/v1/common";
  ssologin = "https://edaface-sso.maticz.in/"
  // domainname = ".maticz.in";
  domainname = ".localhost";

}

let key = {
  Front_URL: Front_URL,
  Back_URL: Back_URL,
  Common_URL : Common_URL,
  v1Url: v1Url,
  vUrl: v1Url,
  decimalvalues: decimalvalues,
  toFixed: toFixed,
  NumOnly: NumOnly,
  toasterOption: toasterOption,
  Users_URL: Users_URL,
  shareTag: shareTag,
  KEY: KEY,
  loginurl: loginurl,
  cookiename: cookiename,
  domainname: domainname,
  userCookieName: userCookieName,
  EnvName: EnvName,
  ssologin ,
};

export default key;
